import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "0.5",
      y: "5",
      width: "14",
      height: "14",
      rx: "3",
      transform: "rotate(-5 0.5 5)",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.347 0.17119L10.315 0.168391C9.50528 0.0975401 8.85216 0.0403936 8.31949 0.0373338C7.77104 0.0341832 7.2845 0.0863367 6.82225 0.2731C6.08799 0.569759 5.4665 1.09125 5.04684 1.76284C4.78265 2.18564 4.6468 2.65573 4.55467 3.1964C4.5183 3.40982 4.48727 3.6444 4.4585 3.90204C4.68518 3.88081 4.92677 3.85967 5.18419 3.83715L5.98565 3.76704C6.00066 3.65363 6.0164 3.54783 6.03335 3.44838C6.10985 2.99946 6.20144 2.74571 6.31892 2.55772C6.57071 2.15477 6.9436 1.84187 7.38416 1.66388C7.5897 1.58083 7.85549 1.53469 8.31088 1.53731C8.77504 1.53998 9.36706 1.59119 10.2163 1.66548L14.5995 2.04897C15.4487 2.12326 16.0407 2.17564 16.4982 2.25361C16.9472 2.33011 17.2009 2.42171 17.3889 2.53918C17.7919 2.79097 18.1047 3.16387 18.2827 3.60442C18.3658 3.80996 18.4119 4.07576 18.4093 4.53114C18.4066 4.9953 18.3554 5.58733 18.2811 6.43654L17.8977 10.8198C17.8234 11.669 17.771 12.2609 17.693 12.7185C17.6165 13.1674 17.5249 13.4212 17.4074 13.6092C17.1557 14.0121 16.7828 14.325 16.3422 14.503C16.2762 14.5297 16.204 14.5525 16.1213 14.5712C16.126 14.6881 16.1287 14.7999 16.1294 14.9068C16.1318 15.3388 16.1 15.7324 15.9951 16.106C16.3139 16.0753 16.6138 16.0111 16.9041 15.8938C17.6384 15.5971 18.2599 15.0756 18.6795 14.404C18.9437 13.9812 19.0796 13.5111 19.1717 12.9705C19.2612 12.4454 19.3183 11.7923 19.3891 10.9825L19.3919 10.9505L19.7754 6.56727L19.7782 6.53527C19.8491 5.72553 19.9062 5.07242 19.9093 4.53975C19.9124 3.9913 19.8603 3.50477 19.6735 3.04251C19.3769 2.30825 18.8554 1.68676 18.1838 1.2671C17.761 1.00291 17.2909 0.867062 16.7502 0.774927C16.2251 0.685443 15.572 0.628309 14.7622 0.557473L14.7303 0.554675L10.347 0.17119Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.37109 14.9619L15.3178 13.7417",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }